import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';
import { MainButton } from '../styledComponent/Buttons.style';

import { TitleAndDescriptionProps } from './BaseStep';
import { CircularProgress } from '@mui/material';

const DivIButton = styled.div`
  margin: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 600px) {
    background-color: ${getColor('DARK_CREAM')};
    width: 100%;
    margin: 0;
    padding: 16px 24px;
  }
`;

const DivInformation = styled.div`
  width: 120px;
  color: ${getColor('BLACK_60')};
`;

const H5 = styled.h5`
  color: ${getColor('BLACK')};
  font-weight: 600;
`;

interface MainFunnelButtonProps {
  text: string;
  onClick: () => void;
  disabled: boolean;
  paymentInformation?: TitleAndDescriptionProps;
  id: string;
  isLoading?: boolean;
}

export const MainFunnelButton = ({
  text,
  onClick,
  disabled,
  paymentInformation,
  id,
  isLoading = false,
}: MainFunnelButtonProps) => {
  return (
    <DivIButton>
      {paymentInformation ? (
        <DivInformation>
          <H5>{paymentInformation.title}</H5>
          <p>{paymentInformation.description}</p>
        </DivInformation>
      ) : (
        ''
      )}
      <MainButton id={id} disabled={disabled || isLoading} onClick={onClick} isThereText={Boolean(paymentInformation)}>
        {isLoading ? <CircularProgress color={'inherit'} size={'2rem'} /> : text}
      </MainButton>
    </DivIButton>
  );
};
